import { Target } from "lucide-react";

export function CategoryGoalsCard({ categories, expenses, viewMode }) {
    const categoriesWithGoal = (categories || []).filter(
        (c) => c.categoria_meta_valor !== null && c.categoria_meta_valor !== undefined
    );

    const realizadoByCategory = (expenses || []).reduce((acc, exp) => {
        acc[exp.categoria_id] = (acc[exp.categoria_id] || 0) + exp.transacao_valor;
        return acc;
    }, {});

    const goals = categoriesWithGoal.map((c) => {
        const metaMensal = Number(c.categoria_meta_valor);
        const meta = viewMode === 'annual' ? metaMensal * 12 : metaMensal;
        const realizado = realizadoByCategory[c.categoria_id] || 0;
        const percent = meta > 0 ? Math.min((realizado / meta) * 100, 100) : 0;
        const overBudget = meta > 0 && realizado > meta;
        return { id: c.categoria_id, name: c.categoria_nome, meta, realizado, percent, overBudget };
    });

    return (
        <div className="card custom-card h-100">
            <div className="card-body p-4">
                <div className="d-flex align-items-center gap-3 mb-4">
                    <div className="icon-container icon-container-custom">
                        <Target size={16} className="text-muted-custom" />
                    </div>
                    <div>
                        <h3 className="h5 fw-semibold mb-0">Metas por Categoria</h3>
                        <p className="text-muted-custom small mb-0">
                            Planejado vs. realizado {viewMode === 'annual' ? '(meta mensal anualizada)' : 'no mês'}
                        </p>
                    </div>
                </div>

                {goals.length === 0 ? (
                    <p className="text-muted-custom small mb-0">
                        Defina uma meta mensal em uma categoria para ver o comparativo aqui.
                    </p>
                ) : (
                    <div className="d-flex flex-column gap-3">
                        {goals.map((goal) => (
                            <div key={goal.id}>
                                <div className="d-flex justify-content-between align-items-baseline mb-1">
                                    <span className="small fw-medium">{goal.name}</span>
                                    <span className={`small ${goal.overBudget ? 'text-danger-custom' : 'text-muted-custom'}`}>
                                        R${goal.realizado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        {' / '}
                                        R${goal.meta.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </span>
                                </div>
                                <div className="progress" style={{ height: '8px', backgroundColor: 'var(--color-border)' }}>
                                    <div
                                        className="progress-bar"
                                        role="progressbar"
                                        style={{
                                            width: `${goal.percent}%`,
                                            backgroundColor: goal.overBudget ? 'var(--color-danger)' : 'var(--color-primary)',
                                        }}
                                        aria-valuenow={goal.percent}
                                        aria-valuemin={0}
                                        aria-valuemax={100}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
